import { type UseQueryResult, useQuery } from 'react-query';
import type { PagedResultDto_TransactionList } from '../../services/wealthlane-award-services/models/PagedResultDto_TransactionList';
import { TransactionService } from '../../services/wealthlane-award-services/services/TransactionService';

export interface CsHistoryFilterParams {
  approvalStatusIds?: Array<number | null>;
  fromDate?: string;
  toDate?: string;
  taxCollectionStatuses?: Array<number | null>;
  transferAllocateStatuses?: Array<number | null>;
  settlementStatuses?: Array<number | null>;
  awardTypes?: Array<string | null>;
  settlementTypes?: Array<string | null>;
  recordTypes?: Array<string | null>;
  transactionStatus?: Array<number | null>;
  cancelStatusId?: Array<string | null>;
  orderStatusId?: Array<string | null>;
  filter?: string;
}

const useGetCsTransactionHistory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  participantId?: string,
  companyId?: string,
  sorting?: string,
  skipCount: number = 0,
  maxResultCount: number = 10,
  filters?: CsHistoryFilterParams
): UseQueryResult<PagedResultDto_TransactionList | undefined, unknown> => {
  return useQuery(
    [
      'getCsTransactionHistory',
      participantId,
      companyId,
      sorting,
      skipCount,
      maxResultCount,
      filters,
    ],
    async () => {
      if (!participantId) return undefined;
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTransactionListForBrokerTradeTool(
          companyId,
          participantId,
          filters?.approvalStatusIds,
          filters?.fromDate,
          filters?.toDate,
          filters?.taxCollectionStatuses,
          filters?.transferAllocateStatuses,
          filters?.settlementStatuses,
          filters?.awardTypes,
          filters?.settlementTypes,
          filters?.recordTypes,
          filters?.transactionStatus,
          filters?.cancelStatusId,
          filters?.orderStatusId,
          filters?.filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      enabled: !!participantId,
    }
  );
};

export default useGetCsTransactionHistory;
